/* Dawn 15.4.0 Cart Drawer Billionaire Optimized */

const drawerDomParser = new DOMParser();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.innerContainer = this.querySelector('.drawer__inner');
    this.emptyContainer = this.querySelector('.drawer__inner-empty');

    this.sectionsToRender = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];

    this.bindEvents();
    this.setupHeaderIcon();
  }

  bindEvents() {
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });
  }

  setupHeaderIcon() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;

    cartIcon.setAttribute('role', 'button');
    cartIcon.setAttribute('aria-haspopup', 'dialog');

    cartIcon.addEventListener('click', (evt) => {
      evt.preventDefault();
      this.open(cartIcon);
    });

    cartIcon.addEventListener('keydown', (evt) => {
      if (evt.code.toUpperCase() === 'SPACE') {
        evt.preventDefault();
        this.open(cartIcon);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const summary = this.querySelector('[id^="Details-"] summary');
    if (summary && !summary.hasAttribute('role')) {
      this.setSummaryAccessibility(summary);
    }

    this.classList.add('animate');

    requestAnimationFrame(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const empty = this.classList.contains('is-empty');
        const container = empty ? this.emptyContainer : document.getElementById('CartDrawer');

        const focusTarget =
          this.innerContainer ||
          this.querySelector('.drawer__close');

        if (container && focusTarget) {
          trapFocus(container, focusTarget);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(el) {
    el.setAttribute('role', 'button');
    el.setAttribute('aria-expanded', 'false');

    const panel = el.nextElementSibling;
    if (panel && panel.id) {
      el.setAttribute('aria-controls', panel.id);
    }

    el.addEventListener('click', (evt) => {
      const root = evt.currentTarget.closest('details');
      const expanded = root && root.hasAttribute('open');
      evt.currentTarget.setAttribute('aria-expanded', !expanded);
    });

    el.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (this.innerContainer && this.innerContainer.classList.contains('is-empty')) {
      this.innerContainer.classList.remove('is-empty');
    }

    this.sectionsToRender.forEach((section) => {
      const target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!target) return;

      const sectionHtml = parsedState.sections[section.id];
      if (!sectionHtml) return;

      const nextInner = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (nextInner !== '' && nextInner !== target.innerHTML) {
        target.innerHTML = nextInner;
      }
    });

    requestAnimationFrame(() => this.open());
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = drawerDomParser.parseFromString(html, 'text/html');
    const node = selector ? doc.querySelector(selector) : doc.body;
    return node ? node.innerHTML : '';
  }

  getSectionsToRender() {
    return this.sectionsToRender;
  }
}

customElements.define('cart-drawer', CartDrawer);

/* Cart Drawer Items Billionaire Extension */

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.drawerSections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionsToRender() {
    return this.drawerSections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
